import React, { useState } from 'react'
import CompanyData from './CompanyData'
import CompanyUsers from './CompanyUsers'
import CompantMasterAgentCategory from './CompanyMasterAgentCategory'
import { useCompany } from 'models'
import { CompanyContext } from './CompanyContext'
import { Container, Row } from 'react-bootstrap'
import { ListAltOutlined } from '@material-ui/icons'
import CompanyGroup from './CompanyGroup'

export default function Company() {
  const [company] = useState(useCompany().company)

  return (
    <CompanyContext.Provider value={company}>
      <Container>
        <Row className="mt-4">
          <ListAltOutlined className="icon-title" />
          <h5 className="title-dashboard">Dados da Revenda</h5>
        </Row>
        <CompanyData />
        {/* {company.is_masteragent ? (
          <CompantMasterAgentCategory />
        ):(<></>)} */}
        <CompanyUsers />
        <CompanyGroup />
      </Container>
    </CompanyContext.Provider>
  )
}